/* Chargement du manifeste média + cache des vidéos (Wi-Fi uniquement). */
let manifestPromise = null;

const BACKEND = process.env.REACT_APP_BACKEND_URL;
let overridesPromise = null;

/* Vidéos originales Bombacare déposées par le fondateur (filigrane incrusté) : remplacent les vidéos par défaut. */
export function loadVideoOverrides() {
  if (!overridesPromise) {
    overridesPromise = fetch(`${BACKEND}/api/videos/overrides`).then((r) => r.json()).then((o) => { localStorage.setItem("bc_video_overrides", JSON.stringify(o)); return o; })
      .catch(() => { try { return JSON.parse(localStorage.getItem("bc_video_overrides") || "{}"); } catch { return {}; } });
  }
  return overridesPromise;
}

export function loadManifest() {
  if (!manifestPromise) {
    manifestPromise = Promise.all([fetch("/illustrations/manifest.json").then((r) => r.json()), loadVideoOverrides()])
      .then(([m, o]) => ({ ...m, exercises: m.exercises.map((e) => (o[e.id] ? { ...e, video: o[e.id], video_originale: true } : e)) }));
  }
  return manifestPromise;
}

export const mediaUrl = (rel) => (rel ? (rel.startsWith("/api/") ? `${BACKEND}${rel}` : rel.startsWith("http") ? rel : `/${rel}`) : null);

const WIFI_KEY = "bc_wifi_videos";
export const getWifiSetting = () => localStorage.getItem(WIFI_KEY) === "1";
export const setWifiSetting = (v) => localStorage.setItem(WIFI_KEY, v ? "1" : "0");

/** True si le navigateur indique une connexion cellulaire (données mobiles). */
export function isCellular() {
  const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (!c) return false;
  return c.type === "cellular" || c.saveData === true;
}

export async function isVideoCached(rel) {
  if (!("caches" in window) || !rel) return false;
  const cache = await caches.open("bc-media-v1");
  return Boolean(await cache.match(mediaUrl(rel)));
}

export async function downloadVideos(onProgress) {
  const m = await loadManifest();
  const videos = m.exercises.map((e) => e.video).filter(Boolean);
  const cache = await caches.open("bc-media-v1");
  let done = 0;
  for (const v of videos) {
    try { await cache.add(mediaUrl(v)); } catch (e) { /* skip */ }
    done += 1;
    onProgress?.(done, videos.length);
  }
  return videos.length;
}

export async function clearVideos() {
  const m = await loadManifest();
  const cache = await caches.open("bc-media-v1");
  for (const e of m.exercises) if (e.video) await cache.delete(mediaUrl(e.video));
}

/** Joue l'audio de l'étape ; replie sur la synthèse vocale si le fichier manque. */
export function playStepAudio(rel, fallbackSpeak) {
  if (!rel) { fallbackSpeak(); return; }
  const a = new Audio(mediaUrl(rel));
  a.onerror = () => fallbackSpeak();
  a.play().catch(() => fallbackSpeak());
}
